<template>
  <div>
    <v-menu
      v-model="open"
      offset-y
      transition="slide-y-transition"
      content-class="menu-offset-class"
    >
      <template v-slot:activator="{ on, attr }" v-if="user">
        <div
          v-bind="attr"
          v-on="on"
          style="cursor: pointer"
          class="flex-row-end-center gap-2"
        >
          <v-icon color="secondaryText">
            {{ open ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
          <div class="text-body-2 secondaryText--text">
            {{ $t("operator") }} {{ user.personalId }}
          </div>
        </div>
      </template>

      <v-card class="flex-col-start-start gap-3 pa-4" style="min-width: 200px">
        <div
          class="text-caption flex-row-between-center gap-4 w-100"
          v-for="(value, title) in profileItems"
          :key="title"
        >
          <div class="secondaryText--text">{{ $t(title) }}:</div>
          <div>{{ value }}</div>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import { GET_USER } from "@/core/services/store/modules/user/user.module";
import { mapGetters } from "vuex";

export default {
  name: "TopProfile",

  data() {
    return {
      open: false,
    };
  },

  computed: {
    ...mapGetters(["user", "userFullName"]),
    profileItems() {
      return {
        personalId: this.user.personalId,
        operatorName: this.userFullName,
        phoneNumber: this.user.phoneNumber,
        workSchedule: this.$t(this.user.workSchedule),
      };
    },
  },

  async created() {
    await this.$store
      .dispatch(GET_USER)
      .then()
      .catch((error) => {
        this.$store.commit(SET_ALERT, {
          text: error.message,
          isError: true,
        });
      });
  },
};
</script>

<style scoped>
.menu-offset-class {
  margin: 18px 0 0 0;
}
</style>
